// Landing page (`/`). One primary action: create a new board.

import { apiUrl, isTauri } from "../config/backend";
import { openBoardsMenu } from "./boards";

export function renderLanding(root: HTMLElement): void {
  root.innerHTML = "";
  // .eyes-paper-bg supplies the paper fill + grain (and its dark-theme
  // variant); .landing only handles layout. See styles/colors_and_type.css.
  root.classList.add("landing", "eyes-paper-bg");

  const wrap = document.createElement("div");
  wrap.className = "landing__wrap";

  const h1 = document.createElement("h1");
  h1.textContent = "Eyes";
  h1.className = "landing__title";

  // The lede contains a link to the explainer, so it's safe to construct
  // explicitly rather than reaching for innerHTML on user-adjacent text.
  const p = document.createElement("p");
  p.className = "landing__lede";
  p.append(
    document.createTextNode(
      "This is a multiplayer productivity tool for you and others to organize your tasks, built on the concept of an ",
    ),
  );
  const link = document.createElement("a");
  link.href =
    "https://sps.columbia.edu/sites/default/files/2023-08/Eisenhower%20Matrix.pdf";
  link.textContent = "Eisenhower Matrix";
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  p.append(link, document.createTextNode("."));

  const btn = document.createElement("button");
  btn.type = "button";
  btn.className = "btn btn--primary btn--throb";
  btn.textContent = "Create New Board";
  btn.addEventListener("click", async () => {
    btn.disabled = true;
    btn.textContent = "Creating…";
    btn.classList.remove("btn--throb");
    try {
      const r = await fetch(apiUrl("/api/new"), { method: "POST" });
      if (!r.ok) throw new Error(`/api/new returned ${r.status}`);
      const body = (await r.json()) as { id: string };
      window.history.pushState({}, "", "/" + body.id);
      window.dispatchEvent(new PopStateEvent("popstate"));
    } catch (e) {
      btn.disabled = false;
      btn.textContent = "Create New Board";
      btn.classList.add("btn--throb");
      const err = document.createElement("p");
      err.className = "landing__error";
      err.textContent = (e as Error).message;
      wrap.append(err);
    }
  });

  wrap.append(h1, p, btn);

  // Desktop/mobile apps have no URL bar, so a fresh app (on `/`) needs a way to
  // reach an existing board by id/link or a recent one. The web omits this.
  if (isTauri()) {
    const open = document.createElement("button");
    open.type = "button";
    open.className = "btn landing__open-existing";
    open.textContent = "Open existing board";
    open.addEventListener("click", () => openBoardsMenu(open));
    wrap.append(open);
  }

  root.append(wrap);
}
